document.addEventListener('DOMContentLoaded', function () {
  const carouselWrappers = document.querySelectorAll('.carousel-wrapper');

  // 1) Create & append the scroll icon element for each wrapper
  carouselWrappers.forEach((wrapper) => {
    // Create the icon element
    const scrollIcon = document.createElement('div');
    scrollIcon.classList.add('scroll-icon');
    
    // Append it to the wrapper
    wrapper.appendChild(scrollIcon);

    // Attach click listener to scroll upward
    scrollIcon.addEventListener('click', () => {
      // Scroll up by the wrapper’s height
      const wrapperHeight = wrapper.offsetHeight;
      window.scrollBy({
        top: +wrapperHeight,
        left: 0,
        behavior: 'smooth',
      });
    });
  });

  // 2) Function to decide if .has-scroll-icon should be applied
  function toggleScrollIcons() {
    carouselWrappers.forEach((wrapper) => {
      const wrapperHeight = wrapper.offsetHeight;
      const viewportHeight = window.innerHeight;
      
      // If wrapper is taller than (viewport - 200), show the icon
      if (wrapperHeight > viewportHeight - 200) {
        wrapper.classList.add('has-scroll-icon');
      } else {
        wrapper.classList.remove('has-scroll-icon');
      }
    });
  }

  // Run once after everything is laid out
  setTimeout(toggleScrollIcons, 300);

  // Also update on window resize
  window.addEventListener('resize', toggleScrollIcons);
});